/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class AgentSupportedPropertyTypeEnum.
* @enum {}
* @readonly
*/
export default class AgentSupportedPropertyTypeEnum {
    
        /**
         * value: "区分"
         * @const
         */
        "区分" = "区分";

    
        /**
         * value: "一棟"
         * @const
         */
        "一棟" = "一棟";

    
        /**
         * value: "海外不動産"
         * @const
         */
        "海外不動産" = "海外不動産";

    

    /**
    * Returns a <code>AgentSupportedPropertyTypeEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AgentSupportedPropertyTypeEnum} The enum <code>AgentSupportedPropertyTypeEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

